{
  "chargeGroupTableConfig": {
    "columns": [
      {
        "fieldName": "name",
        "displayName": "Name",
        "dataType": "STRING",
        "styleConfig": {
          "highlightSearch": true
        }
      },
      {
        "fieldName": "description",
        "displayName": "Description",
        "dataType": "STRING"
      },
      {
        "fieldName": "invoiceHeaderTitle",
        "displayName": "Invoice Header Title",
        "dataType": "STRING"
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "operationalProcess.id",
        "displayName": "Operational Process",
        "dataType": "STRING"
      },
      {
        "fieldName": "createdDate",
        "displayName": "Created Date",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ]
  },
  "searchBarConfig": {
    "placeHolder": "Search charge group by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "Name"
      },
      {
        "name": "CODE_CONTAINS",
        "alias": "Code"
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "name",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "NAME_EQUALS",
          "CONTAINS": "NAME_CONTAINS"
        }
      },
      {
        "name": "isActive",
        "displayLabel": "Active",
        "dataType": "CHECKBOX",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      },
      {
        "name": "charges",
        "displayLabel": "Charges",
        "dataType": "STRING",
        "hasLookup": true,
        "searchConfig": {
          "apiUrl": "v1/charges/list",
          "filterByKeys": ["NAME_CONTAINS", "CODE_CONTAINS"],
          "limit": 10,
          "multiSelect": true,
          "orderBy": { "name": "asc" },
          "bindLabel": "name",
          "returnRawValue": false,
          "bindValue": "id",
          "displayColumns": [{ "key": "name", "header": "Name" }],
          "additionalFilters":{
            "name": "IS_ACTIVE",
            "alias": "active",
            "operator": "EQ",
            "value": ["true"]
          }
        },
        "operatorToFilterMap": {
          "IN": "CHARGE_CONTAINS"
        }
      }
    ],
    "useNewContract": true
  }
}
